// extracted by extract-css-chunks-webpack-plugin
module.exports = {"modalWrapper":"_4EZXj","modalBlock":"EmrDF","modalContent":"yTinX","modalHeaderIcon":"etDec","success":"_8yJ5u","warning":"pV5SW","error":"GkFfd"};